
import React from "react";
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Navbar from "../components/navbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import "./pages.css";
import imageList from '../imageList.json';

function Icing() {

  return (
    <div className="pages__container">
    <Container className="header__section">
      <Row >
        <Navbar />
      </Row>
    </Container>
    <Container>
      <Row className="body__container">
          <div className="header__content">All Icing Cakes</div>
          <CardGroup>
          {imageList.map((imagePath, index) => (
              (imagePath.indexOf('icing') !== -1) && 
                <Row className="col-sm-6 col-lg-3 row-card ">
                  <Card style={{display:'flex',flexWrap:'noWrap'}}>
                  <Card.Img  src={`/images/${imagePath}`} alt={`Image ${index}`} />
                  <Card.Body>
                  </Card.Body>
                </Card>
                </Row>
              ))}
          </CardGroup>
      </Row>
    </Container>
  </div>
  );
}

export default Icing;